// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historyButton_z5IqP {
  width: 310px;
  height: 75px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 30px;
}
.buttontext_cYKyf {
  font-size: 20px;
  font-weight: 700;
  padding-right: 100px;
  margin-right: 'auto';
}
.reactQuill_tLr_Q {
  height: 150px;
  border: none;
  margin-bottom: 30px;
}
.currentstatus__uURw {
  font-size: 12px;
  background-color: #ffefd3;
  color: #bf913c;
  width: 70px;
  margin-bottom: 3px;
  margin-top: 3px;
}
.table_VcH5y {
  width: 100%;
  margin-top: 50px;
}
.comLogimage_pK7ys {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.container_hG7cV {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.setDateStyle_GhpnK {
  margin-right: 35px;
}
.dotdivStyle_ysP4y {
  margin-right: 35px;
  margin-left: 15px;
}
.buttonDiv_Ehd6h {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.containerAB_PpVep {
  display: flex;
  flex-direction: column;
}
.select_container_PNAcH {
  display: flex;
  justify-content: flex-end;
  /* Aligns the select container to the right */
  margin-top: 20px;
}
.select_wrapper_wT_Ow {
  width: 50%;
  /* Adjust the width of the select container as needed */
}
.table-container_yjlso {
  width: 100%;
  /* Makes the table container occupy 100% width */
}
.tableButton_YWY0H {
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 8px;
  width: 70px;
  text-align: center;
  justify-content: center;
}
.misstingInfo_WGXrV {
  padding: 20px;
  width: 100%;
  background-color: #fae8e3;
  margin-bottom: 20px;
  color: #838ba1;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/GlobelSearchClientDashboard/Buttons/taps.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAEA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AAAJ;AAEA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAEA;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAAJ;AAEA;EACI,WAAA;EACA,gBAAA;AAAJ;AAGA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AADJ;AAGA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AADJ;AAGA;EACI,kBAAA;AADJ;AAGA;EACI,kBAAA;EACA,iBAAA;AADJ;AAGA;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AADJ;AAGA;EACI,aAAA;EACA,sBAAA;AADJ;AAIA;EACI,aAAA;EACA,yBAAA;EAFF,6CAA6C;EAG3C,gBAAA;AADJ;AAIA;EACI,UAAA;EAFF,uDAAuD;AACzD;AAIA;EACI,WAAA;EAFF,gDAAgD;AAClD;AAIA;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AAFJ;AAIA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAFJ","sourcesContent":[".historyButton {\n    width: 310px;\n    height: 75px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n\n.buttontext {\n    font-size: 20px;\n    font-weight: 700;\n    padding-right: 100px;\n    margin-right: 'auto';\n}\n.reactQuill {\n    height: 150px;\n    border: none;\n    margin-bottom: 30px;\n}\n.currentstatus {\n    font-size: 12px;\n    background-color: #ffefd3;\n    color: #bf913c;\n    width: 70px;\n    margin-bottom: 3px;\n    margin-top: 3px;\n}\n.table {\n    width: 100%;\n    margin-top: 50px;\n}\n\n.comLogimage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n.container {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n}\n.setDateStyle {\n    margin-right: 35px;\n}\n.dotdivStyle {\n    margin-right: 35px;\n    margin-left: 15px;\n}\n.buttonDiv {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n}\n.containerAB {\n    display: flex;\n    flex-direction: column;\n}\n\n.select_container {\n    display: flex;\n    justify-content: flex-end; /* Aligns the select container to the right */\n    margin-top: 20px;\n}\n\n.select_wrapper {\n    width: 50%; /* Adjust the width of the select container as needed */\n}\n\n.table-container {\n    width: 100%; /* Makes the table container occupy 100% width */\n}\n\n.tableButton {\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-left: 5px;\n    padding-right: 5px;\n    border-radius: 8px;\n    width: 70px;\n    text-align: center;\n    justify-content: center;\n}\n.misstingInfo {\n    padding: 20px;\n    width: 100%;\n    background-color: #fae8e3;\n    margin-bottom: 20px;\n    color: #838ba1;\n    font-size: 18px;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyButton": `historyButton_z5IqP`,
	"buttontext": `buttontext_cYKyf`,
	"reactQuill": `reactQuill_tLr_Q`,
	"currentstatus": `currentstatus__uURw`,
	"table": `table_VcH5y`,
	"comLogimage": `comLogimage_pK7ys`,
	"container": `container_hG7cV`,
	"setDateStyle": `setDateStyle_GhpnK`,
	"dotdivStyle": `dotdivStyle_ysP4y`,
	"buttonDiv": `buttonDiv_Ehd6h`,
	"containerAB": `containerAB_PpVep`,
	"select_container": `select_container_PNAcH`,
	"select_wrapper": `select_wrapper_wT_Ow`,
	"table-container": `table-container_yjlso`,
	"tableButton": `tableButton_YWY0H`,
	"misstingInfo": `misstingInfo_WGXrV`
};
export default ___CSS_LOADER_EXPORT___;
